import { FaHeartbeat, FaFacebook, FaLinkedin, FaInstagram, FaEnvelope, FaPhone } from 'react-icons/fa';
import Button from './ui/Button';
import './Footer.css';

const PRODUCT_LINKS = [
  { label: 'General Surgery Catalog', href: '/catalogs/general-surgery' },
  { label: 'Orthopedic Hand Catalog', href: '/catalogs/orthopedic/hand' },
  { label: 'Locking Plates',          href: '/catalogs/orthopedic/locking-plates' },
  { label: 'Non-Locking Plates',      href: '/catalogs/orthopedic/non-locking-plates' },
  { label: 'Dental Catalog',          href: '/catalogs/dental' },
  { label: 'Complete Catalog',        href: '/catalogs/complete' },
];

const COMPANY_LINKS = [
  { label: 'About Us',      href: '/#about' },
  { label: 'Our Products',  href: '/#products' },
  { label: 'Catalogs',      href: '/catalogs' },
  { label: 'Why Choose Us', href: '/#why-us' },
  { label: 'Global Export', href: '/#export' },
  { label: 'Contact Us',    href: '/#contact' },
];

const SOCIALS = [
  { icon: <FaFacebook />,  label: 'Facebook',  href: 'https://www.facebook.com/share/18yxAnuF9Y/' },
  { icon: <FaLinkedin />,  label: 'LinkedIn',  href: 'https://www.linkedin.com/company/ha-surgical/' },
  { icon: <FaInstagram />, label: 'Instagram', href: 'https://www.instagram.com/h.a_surgical?igsh=d3Z6eGgwajJocW1j' },
];

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer__top">
        <div className="container footer__grid">

          <div className="footer__brand">
            <a href="/" className="footer__logo">
              <FaHeartbeat aria-hidden="true" />
              <div>
                <span className="footer__logo-name">H.A Surgical</span>
                <span className="footer__logo-sub">Medical Instruments</span>
              </div>
            </a>
            <p className="footer__brand-desc">
              Premium surgical instrument manufacturer from Sialkot, Pakistan.
              Exporting quality to 40+ countries worldwide since 1999.
            </p>
            <div className="footer__socials">
              {SOCIALS.map(s => (
                <a key={s.label} href={s.href} target="_blank" rel="noopener noreferrer" aria-label={s.label}>
                  {s.icon}
                </a>
              ))}
            </div>
          </div>

          <div className="footer__col">
            <h4>Products</h4>
            <ul>
              {PRODUCT_LINKS.map(p => (
                <li key={p.label}><a href={p.href}>{p.label}</a></li>
              ))}
            </ul>
          </div>

          <div className="footer__col">
            <h4>Company</h4>
            <ul>
              {COMPANY_LINKS.map(l => (
                <li key={l.label}><a href={l.href}>{l.label}</a></li>
              ))}
            </ul>
          </div>

          <div className="footer__col">
            <h4>Get In Touch</h4>
            <div className="footer__contact-list">
              <div className="footer__contact-item">
                <FaPhone aria-hidden="true" />
                <span>03160813377</span>
              </div>
              <div className="footer__contact-item">
                <FaEnvelope aria-hidden="true" />
                <span>info@ha-surgical.com</span>
              </div>
            </div>
            <Button href="/#contact" variant="primary" className="footer__cta-btn">
              Request a Quote
            </Button>
          </div>

        </div>
      </div>

      <div className="footer__bottom">
        <div className="container footer__bottom-inner">
          <p>&copy; {new Date().getFullYear()} H.A Surgical. All rights reserved. | Sialkot, Pakistan</p>
          <div className="footer__certs">
            <span>ISO 9001</span>
            <span>CE Certified</span>
            <span>FDA Compliant</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
